import { Pipe, PipeTransform } from '@angular/core';
import { BreakpointAvailable } from '@services/responsive';
import { TitleType } from '@shared/components/title/enum';
import { Title } from '@shared/components/title/model';
import { Color, FontType, TextAlign } from '@shared/enums';

@Pipe({
  name: 'getClass',
  standalone: true,
})
export class GetClassPipe implements PipeTransform {
  transform(title: Title, breakpoint: BreakpointAvailable): string[] {
    const base = [
      `color-${title.color ? title.color.toLowerCase() : Color.BLACK}`,
      `font-${title.font ? title.font.toLowerCase() : FontType.IVY_MODE}`,
      `title--${title.type ? title.type.toLowerCase() : TitleType.NORMAL}`,
    ];
    if (breakpoint === 'desktop') {
      return [
        ...base,
        title.size ? `size-${title.size.desktop.toLowerCase()}` : '',
        title.align ? `align-${title.align.desktop.toLowerCase()}` : TextAlign.LEFT,
      ];
    }
    return [
      ...base,
      title.size ? `size-${title.size.mobile.toLowerCase()}` : '',
      title.align ? `align-${title.align.mobile.toLowerCase()}` : TextAlign.LEFT,
    ];
  }
}
